import React, { useRef, useEffect, useState } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { WidgetCard } from '../WidgetCard';
import { Popup, Dropdown, Ref } from 'semantic-ui-react';
import { widgetHeight, widgetWidth } from '..';
import { BottomButtonRow, Message, CardBodyWrapper } from '../Styles';
import ButtonWithConfirmation from '../ButtonWithConfirmation';
import useStores from '../../../../hooks/use-store';
import { useAuctionAndLanes } from '../Streamer/SwitchStreamerWidget';
import { engineToolType } from '../../../../stores/reducers/engineTools';

export const EngineResetLaneWidget = observer(() => {
  const {
    AuctionStore: {
      sortedActiveAuctions,
      getSortedActiveAuctions,
      loadAuctionLaneOptions,
      laneOptions,
    },
    EngineToolStore: { enginePost: post, widgetReloading },
  } = useStores();
  const key = 'reset-lane';
  const [message, setMessage] = useState(null);
  const [success, setSuccess] = useState(null);
  const laneRef = useRef();
  const {
    onAuctionChanged,
    onLaneChanged,
    auction,
    lane,
    isLoadingAuctions,
    isLoadingLanes,
    auctions,
    lanes,
  } = useAuctionAndLanes({
    sortedActiveAuctions,
    getSortedActiveAuctions,
    loadAuctionLaneOptions,
    laneOptions,
    laneRef,
  });

  const statusMessageHandler = ({ success, message }) => {
    setMessage(message);
    setSuccess(success);
  };

  const handleConfirmation = (e) => {
    e.preventDefault();
    post(engineToolType.resetLane, {
      auctionID: auction.auctionId,
      laneID: lane.laneId,
    }).then(statusMessageHandler);
  };

  const isLoading =
    isLoadingAuctions ||
    isLoadingLanes ||
    widgetReloading[engineToolType.resetLane];

  console.log('auction, lane', auction, lane);
  return (
    <WidgetCard
      heading="Reset Lane"
      description="Resets a Lane back to a Pre-Auction state."
      width="450px"
      height="235px"
    >
      <CardBodyWrapper>
        <Dropdown
          placeholder="Select Auction"
          clearable
          fluid
          selection
          options={auctions}
          onChange={(e, data) => {
            onAuctionChanged(data.value, e.currentTarget.textContent);
            statusMessageHandler({ success: null, message: null });
          }}
          disabled={isLoading}
        />
        <Ref innerRef={laneRef}>
          <Dropdown
            placeholder="Select Lane"
            clearable
            fluid
            selection
            options={lanes}
            onChange={(e, data) => {
              onLaneChanged(data.value, e.currentTarget.textContent.text);
              statusMessageHandler({ success: null, message: null });
            }}
            disabled={isLoading}
          />
        </Ref>
      </CardBodyWrapper>
      <BottomButtonRow buttonWidth="150px">
        {message ? (
          <Popup
            data-testid={`${key}-popup`}
            key={key}
            content={message}
            header="Details"
            size="small"
            trigger={
              <Message success={success}>
                {success
                  ? '😃 The lane has been successfully reset!'
                  : '🤔 Oops, an error occurred while trying to reset the lane.'}
              </Message>
            }
          />
        ) : (
          <Message />
        )}
        <ButtonWithConfirmation
          buttonText="Reset Lane"
          buttonIcon="sync"
          onConfirmation={handleConfirmation}
          loading={isLoading}
          disabled={!lane?.laneId}
        />
      </BottomButtonRow>
    </WidgetCard>
  );
});

export default EngineResetLaneWidget;
